<template>
  <div class="home_title_box" :style="`margin-bottom:${titleMarginBottom}px`">
    <div class="home_title_left"><img :src="icon" alt="" />{{ title }}</div>
    <router-link
      :to="link2"
      v-if="link2"
      class="home_title_right"
      :target="newWindow ? '_blank' : ''"
    >
      查看更多 <i class="el-icon-arrow-right"></i>
    </router-link>
    <a
      :href="link"
      class="home_title_right ta3"
      v-show="showMore"
      :target="newWindow ? '_blank' : ''"
      v-else
      >查看更多 <i class="el-icon-arrow-right"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    title: {
      type: String,
      default: "最新教程",
    },
    link: {
      type: String,
      default: "https://lib.yiihuu.com/list/index.php",
    },
    link2: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "@/assets/images/home/home_title/icon1.svg",
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    titleMarginBottom: {
      type: String,
      default: "24",
    },
    newWindow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.home_title_box {
  display: flex;
  justify-content: space-between;
}

.home_title_left {
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  color: #333;
  display: flex;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.home_title_right {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border: 1px solid #e3e5e7;
  border-radius: 5px;
  color: #999;
  font-size: 12px;
  &:hover {
    color: #22b79e;
    border: 1px solid #22b79e;
    i {
      animation: arrowsSlide 0.3s;
    }
  }
}
</style>
